var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"container-hero d-flex align-items-center",attrs:{"fluid":""}},[_c('b-container',{staticClass:"p-0 align-items-center"},[_c('PinFormContainer',{ref:"pinFormContainer"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }